export default __webpack_public_path__ + "static/assets/logo.103b5fa18196d5665a7e12318285c916.svg";